<template>
  <div>
    <AboutHero />
    <StorySection />
    <CoreValues />
    <TeamSection />
    <EvolvedSection />
    <WhatWeDoBest />
    <CertifiedSection />
    <GlobalPresence />
    <ClientsSaySection />
    <ReadyFightSection />
  </div>
</template>

<script>
import GlobalPresence from '@/components/About/SectionEight/GlobalPresence.vue';
import EvolvedSection from '@/components/About/SectionFive/EvolvedSection.vue';
import TeamSection from '@/components/About/SectionFour/TeamSection.vue';
import ClientsSaySection from '@/components/About/SectionNine/ClientsSaySection.vue';
import AboutHero from '@/components/About/SectionOne/AboutHero.vue';
import CertifiedSection from '@/components/About/SectionSeven/CertifiedSection.vue';
import WhatWeDoBest from '@/components/About/SectionSix/WhatWeDoBest.vue';
import ReadyFightSection from '@/components/About/SectionTen/ReadyFightSection.vue';
import CoreValues from '@/components/About/SectionThree/CoreValues.vue';
import StatsBar from '@/components/About/SectionTwo/StatsBar.vue';
import StorySection from '@/components/About/SectionTwo/StorySection.vue';

export default {
  name: 'About',
  components: {
    AboutHero, StorySection, StatsBar, CoreValues, TeamSection,
    EvolvedSection, WhatWeDoBest, CertifiedSection, GlobalPresence,
    ClientsSaySection, ReadyFightSection
  }
}
</script>

<style></style>